export default class Brand {
  id: number;
  name: string;
  domain: string;
  color: string = '';
  key: string;
  logoUrl: string;
  badgeUrl: string;
  urlFAQs: string;
  urlScoring: string;
  urlPrivacy: string;
  urlTerms: string;
  urlRules: string;
  gameLogo: string;
  gameName: string;

  constructor(starter?: any) {
    starter = starter || {};
    this.id = starter.id || null;
    this.name = starter.name || null;
    this.domain = starter.domain || null;
    this.color = starter.color || null;
    this.logoUrl = starter.logoUrl || null;
    this.gameLogo = starter.gameLogo || null;
    this.gameName = starter.gameName || 'Fantasy Challenge';
    this.badgeUrl = starter.badgeUrl || null;
    this.key = starter.key || null;
    this.urlFAQs = starter.urlFAQs || null;
    this.urlScoring = starter.urlScoring || null;
    this.urlPrivacy = starter.urlPrivacy || null;
    this.urlTerms = starter.urlTerms || null;
    this.urlRules = starter.urlRules || null;
  }

  is(key: string): boolean {
    return this.key.toLowerCase() == key.toLowerCase();
  }
}
